import EditPhoneNumberForm from './editMode';
import CreatePhoneNumberForm from './createMode';
import { BaseFormProps, FormOpenMode } from './types';

interface FormProps extends BaseFormProps {
    mode?: FormOpenMode;
}

const CreateEditPhoneNumberForm = ({ mode = 'create', ...rest }: FormProps) => {
    if (mode === 'edit') {
        return <EditPhoneNumberForm {...rest} />;
    }
    return <CreatePhoneNumberForm {...rest} />;
};

export default CreateEditPhoneNumberForm;
